module.exports = __webpack_public_path__ + "static/media/rm_06-22.c6657005.png";